import { motion } from 'framer-motion';
import { ArrowRight, Sparkles, HandshakeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

const CONTACT_INBOX = 'connect@kgob.com';

// "Become a Client" + "Partner" strip — moved out of the hero (Session 61)
// so the hero can showcase services. Sits directly below the hero.
export const ClientPartnerStrip = () => {
  return (
    <section className="bg-[#07182F] border-t border-white/5 py-12" data-testid="client-partner-strip">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
          >
            <Link
              to="/welcome"
              className="group relative block h-full rounded-2xl border border-[#D4AF37]/50 bg-[linear-gradient(180deg,rgba(212,175,55,0.14)_0%,rgba(212,175,55,0.05)_100%)] p-6 backdrop-blur-xl transition-all duration-300 hover:border-[#D4AF37] hover:shadow-[0_12px_40px_rgba(212,175,55,0.18)]"
              data-testid="strip-become-client-card"
            >
              <span className="absolute top-3 right-3 inline-flex items-center gap-1.5 rounded-full bg-[#D4AF37] px-2.5 py-0.5 text-[9px] tracking-[0.16em] uppercase text-[#0B2240] font-bold shadow-sm">
                <Sparkles className="w-2.5 h-2.5" />
                Start here
              </span>
              <div className="flex items-start justify-between mb-3">
                <Sparkles className="h-7 w-7 text-[#D4AF37]" />
                <ArrowRight className="h-5 w-5 text-white/60 transition-all duration-200 group-hover:text-white group-hover:translate-x-1" />
              </div>
              <h3 className="font-['Playfair_Display'] text-xl font-semibold mb-2 text-[#F7F2E0]">
                Become a Client
              </h3>
              <p className="text-sm font-medium mb-2 text-[#E3C96E]">For those ready to make the change.</p>
              <p className="text-sm leading-relaxed text-white/70">
                Start with our prospective-client onboarding form. New engagements are accepted by application.
              </p>
              <p className="mt-3 text-[11px] tracking-[0.14em] uppercase text-[#D4AF37]/80 font-semibold">
                By application &middot; approval required
              </p>
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.08 }}
          >
            <a
              href={`mailto:${CONTACT_INBOX}?subject=Partnership%20with%20KGOB`}
              className="group relative block h-full rounded-2xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-xl transition-all duration-300 hover:border-white/20 hover:bg-white/[0.06]"
              data-testid="strip-partner-card"
            >
              <span className="absolute top-3 right-3 inline-flex items-center gap-1.5 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/40 px-2 py-0.5 text-[9px] tracking-[0.14em] uppercase text-[#E3C96E] font-semibold">
                <span className="w-1 h-1 rounded-full bg-[#E3C96E]" />
                Accepting soon
              </span>
              <div className="flex items-start justify-between mb-3">
                <HandshakeIcon className="h-7 w-7 text-[#D4AF37]/70" />
                <ArrowRight className="h-5 w-5 text-white/40 transition-all duration-200 group-hover:text-white/70" />
              </div>
              <h3 className="font-['Playfair_Display'] text-xl font-semibold mb-2 text-white">
                I'm a Partner
              </h3>
              <p className="text-sm font-medium mb-2 text-[#E3C96E]/75">
                For those who want to build something greater together.
              </p>
              <p className="text-sm leading-relaxed text-white/55">
                We are accepting new entries soon. To open a partnership conversation, write to us.
              </p>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
